<template>
  <TableRightColumn
    class="ManageCategories"
    :show-categories="showCategories"

    :title="title"
    :description="description"
  >
    <Categories
      :editable="false"
      :viewportHeight="viewportHeight"
      :loading="loading"
      :remove-skeleton-class="removeSkeletonClass"
      :removeCardStyle="removeCardStyle"
      :heightLimit="heightLimit"
      :removeSkeletonArray="true"
      :full-page="false"
      :white-bg="true"

      @root-categories="val => tableRootCategories = val"
      @sub-categories="val => tableSubCategories = val"

      ref="table"
    >
      <template #before-category="{item}">
        <FormCheckbox
          :value="categories.some(cat => cat.uid === item.uid)"
          @click.native.stop.prevent="selectSubcategory(item)"
        ></FormCheckbox>
      </template>

      <!-- <template #after-category="{item, isSubcategory, loading}">
        <span v-if="!loading" class="main-category-radio disable-ske" @click.stop.prevent>
          <FormCustomRadio class="main-category-radio-button"
            :value="main_category === item.uid"
            @click.native="setMainCategory(item)"
          />
        </span>
      </template> -->
    </Categories>
  </TableRightColumn>
</template>

<script>

import TableRightColumn from "./Table/TableRightColumn.vue"
import Categories from "../pages/Categories.vue"
import FormCheckbox from "../components/Inputs/FormCheckbox.vue"
import FormCustomRadio from "../components/Inputs/FormCustomRadio.vue"

export default {
  components: {
    FormCheckbox,
    TableRightColumn,
    Categories,
    FormCustomRadio,
  },
  props: {
    viewportHeight: Boolean,
    removeCardStyle: Boolean,
    heightLimit: String,

    removeSkeletonClass: {
      type: Boolean,
      default: true,
    },
    product: {
      type: Object,
      required: false,
    },
    showCategories: {
      type: Boolean,
      required: false,
    },
    updateProduct: {
      type: Function,
      required: true,
    },
    loadProduct: {
      type: Function,
      required: false,
    },

    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    handlePromise: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      tableRootCategories: [],
      tableSubCategories: [],
    }
  },
  created() {
    if (this.categories.length) {
      this.loading = false
    }
  },
  methods: {
    collapseAlreadyEnabledSubcategories() {
      // DEAL WITH THIS
      const productCategories = this.categories
      this.tableRootCategories && this.tableRootCategories.forEach(cat => {
        if (cat.sub_categories && productCategories.some(prodCat => cat.sub_categories.some(sub => prodCat.uid === sub.uid))) {
          this.$refs.table.collapseSubCategory(cat.uid)
        }
      })
    },

    async updateCategories({ categories = this.categories }) {
      const callback = async () => {
        await this.updateProduct({
          categories: categories.map(cat => typeof cat === "string" ? cat : cat.uid),
        })

        if (this.loadProduct) await this.loadProduct()
      }

      if (this.handlePromise) {
        this.loading = true

        await this.$handlePromise(callback)

        this.$success("Productcategorie geüpdatet!")
        this.loading = false
      } else callback()
    },

    selectSubcategory(item) {
      const categories = this.categories.slice()

      if (item.parent_category) {
        const subCategory = this.tableRootCategories.find(cat => cat.uid === item.parent_category)
        if (subCategory && !categories.find(cat => cat.uid === item.parent_category)) categories.push(subCategory)
      }

      const index = categories.findIndex(cat => cat.uid === item.uid)
      if (index > -1) {
        categories.splice(index, 1)
      } else {
        categories.push(item)
      }

      console.log(categories)
      this.updateCategories({ categories })
    },
  },
  computed: {
    categories() {
      const product = this.product
      return (product && product.categories.slice()) || []
    },
  },
  watch: {
    product(val) {
      if (val) {
        this.loading = false
        this.collapseAlreadyEnabledSubcategories()
      }
    },
    tableRootCategories() {
      if (this.product) this.collapseAlreadyEnabledSubcategories()
    },
    tableSubCategories() {
      if (this.product) this.collapseAlreadyEnabledSubcategories()
    },
  },
}

// right: 105px;

</script>

<style>

.ManageCategories .header-wrapper,
.ManageCategories .header-wrapper > div {
  display: flex !important;
}

.ManageCategories .header-wrapper > div > div {
  width: 100%;
  flex-basis: 100%;
  flex-grow: 1;
}

.ManageCategories .header-wrapper > div {
  width: 100%;
  flex-basis: 100%;
  flex-grow: 1;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.ManageCategories tbody {
  border: 1px solid #EFEFF0;
}

</style>

<style scoped>

.main-category-radio-button {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 25px;
  width: 15px;
  cursor: pointer !important;
  z-index: 30;
}

</style>
